var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.22 7.22a.75.75 0 011.13.98l-.07.08-3.47 3.47 3.47 3.47c.27.27.3.68.07.98l-.07.08a.75.75 0 01-.98.07l-.08-.07-4-4a.75.75 0 01-.07-.98l.07-.08 4-4z"
  })));
}
export default SvgChevronLeft;